module.exports = __webpack_public_path__ + "5c9159c46890d754c970807a1ae9e1bf.svg";